export var GameStatus;
(function (GameStatus) {
    GameStatus[GameStatus["POPULAR"] = 1] = "POPULAR";
    GameStatus[GameStatus["ONLINE"] = 2] = "ONLINE";
    GameStatus[GameStatus["MAINTENANCE"] = 3] = "MAINTENANCE";
    GameStatus[GameStatus["STOP_SALE"] = 4] = "STOP_SALE";
    GameStatus[GameStatus["REMOVED"] = 5] = "REMOVED"; // 遊戲已移除，紀錄保留
})(GameStatus || (GameStatus = {}));
//# sourceMappingURL=GameStatus.js.map